import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import * as m from "../paraglide/messages.js";

export default function Blog() {
  const isEnglish = document.documentElement.lang === "en";
  const canonical = isEnglish ? "https://scalingwebs.com/en/blog" : "https://scalingwebs.com/blog";

  useEffect(() => {
    const container = document.getElementById("soro-blog");
    if (!container) return;

    const existingScript = container.nextElementSibling;
    if (existingScript && existingScript.tagName === "SCRIPT") {
      existingScript.remove();
    }

    const script = document.createElement("script");
    const params = new URLSearchParams(window.location.search);
    let url = "https://app.trysoro.com/api/embed/d265f3d4-1798-45d5-8a28-6a93c356a194";
    const post = params.get("post");
    if (post) {
      url += `?post=${encodeURIComponent(post)}`;
    }
    script.src = url;
    container.after(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Helmet>
        <title>{m.blog_title()}</title>
        <meta name="description" content={m.blog_description()} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={m.blog_title()} />
        <meta property="og:description" content={m.blog_description()} />
        <meta property="og:url" content={canonical} />
        <meta name="twitter:title" content={m.blog_title()} />
        <meta name="twitter:description" content={m.blog_description()} />
        <link rel="alternate" hrefLang="et" href="https://scalingwebs.com/blog" />
        <link rel="alternate" hrefLang="en" href="https://scalingwebs.com/en/blog" />
      </Helmet>
      <Navigation />
      <main className="pt-28 pb-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div id="soro-blog"></div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
